import dragger from "./index.vue"
import plugin from "./plugin"
import config from "./config"
export default dragger
export {
    plugin,
    config
}